import { stringValidator } from '#validation/common/validators';
export const passwordValidator = stringValidator({
    requiredError: 'user.password.required',
    minLength: { min: 8, error: 'user.password.minLength' },
    formats: [
        { regex: /\d/, error: 'user.password.digitReq' },
        { regex: /[A-Z]/, error: 'user.password.uppercaseReq' },
        { regex: /[a-z]/, error: 'user.password.lowercaseReq' },
    ],
});
